export const EVENT_VALUES = {
  TITLE: 'My event title',
  COLOR_PRIMARY: '#e3bc08',
  COLOR_SECONDARY: '#fdf1ba',
  LABEL: "<i class='glyphicon glyphicon-pencil'></i>",
  CSS_CLASS: 'aTestClass',
};

export default { EVENT_VALUES };
